import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/casino')({
  component: CasinoLayout,
});

function CasinoLayout() {
  return <Outlet />;
}
